import React, {useState} from 'react';
import { Field, reduxForm } from 'redux-form/immutable';
import PropTypes from 'prop-types';
import NavbarModulo from '../../components/NavbarModulo';
import classNames from 'classnames';
import styled from 'styled-components';
import DetalleVenta from './DetalleVenta';
import DetalleVentaVer from './DetalleVentaVer';
import DetalleVentaMod from './DetalleVentaMod';
import NumberFormat from 'react-number-format';

import {
    AsyncSelectFieldIn,
    AsyncSelectField,
    renderField,
    renderDayPickerB,
    SelectField,
    renderNumber
} from "../../Utils/renderField/renderField";

function VentaEmpleadoForm(props) {
    const { modulo, emp, registroVenta, tipo,
        datosColaborador, cargo, crear, modificarVenta,
        listarProductos, agregarLinea, detallePro, eliminarLinea,
        detalleProducto, agregarLineaProducto, eliminarLineaProducto,
        periodo } = props;

    const editar = window.location.href.includes('editar');
    let titulo = editar ? 'Modificar venta' : 'Crear venta';
    let disabled = false;
    if (crear === false && editar === false) {
        disabled = true;
        titulo = 'Ver venta'
    }
    
    let ruta = window.location.href;
    let id_emp = ruta.split('/');

    const handleOnChangeEmp = value => {
        datosColaborador(value.value);
    };

    const tipoPedido = [
        { label: "Mes", value: 'M' },
        { label: "Emergencia", value: 'E' },
        { label: "Donación", value: 'D' },
    ];

    const estilo = {
        overflow: "auto",
        height: "300px",
    };

    const [precioV, setPrecioVenta] = useState(0.00);
    const [total, setTotal] = useState(0.0);

    const handleOnChangeProducto = value => {
        let pro = value.value.split('#');
        setPrecioVenta(pro[3]);
    };

    return (
        <div>
            <NavbarModulo
                periodoD={periodo}
                modulo={modulo}
                titulo={titulo}
            />
            
            <br />
            <div className="mb-4 card card-small text-white bg-dark mb-3">
                <div className="p-0 pt-3 d-flex flex-column flex-md-row">
                    <div className="d-flex flex-column flex-1 mx-4">
                        <div className='mb-2'>
                            {(crear === false && editar === false) &&
                                <div className='row mb-2'>
                                    <div className='col-6'>
                                        <Field
                                            name="nombre"
                                            placeholder="Colaborador"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="puestoNombre"
                                            placeholder="Puesto"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Puesto"
                                        />
                                    </div>
                                </div>
                            }
                            {crear === true &&
                                <div className='row mb-2'>
                                    <div className='col-6'>
                                        <Field
                                            name="colaborador"
                                            placeholder="Colaborador..."
                                            className="form-control-find"
                                            component={AsyncSelectFieldIn}
                                            loadOptions={emp}
                                            onChange={handleOnChangeEmp}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <div className="form-floating">
                                            <input
                                                className = {classNames('form-control')}
                                                type="text"
                                                value = {cargo}
                                                disabled = {true}
                                            />
                                            <label className='form-label'>Puesto</label>
                                        </div>
                                    </div>
                                </div>
                            }
                            {editar === true &&
                                <div className='row mb-2'>
                                    <div className='col-6'>
                                        <Field
                                            name="nombre"
                                            placeholder="Colaborador"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Colaborador"
                                        />
                                    </div>
                                    <div className='col-6'>
                                        <Field
                                            name="puestoNombre"
                                            placeholder="Puesto"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Puesto"
                                        />
                                    </div>
                                </div>
                            }
                            {crear === false && editar === false &&
                                <div className='row mb-3'>
                                    <div className='col-2'>
                                        <Field
                                            name="fecha"
                                            placeholder="Fecha"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderDayPickerB}
                                            msj="Fecha inicio"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="tipo"
                                                options={tipoPedido}
                                                crear={crear}
                                                dato={tipo}
                                                disabled={true}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Tipo"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="pedido"
                                            placeholder="Serie / Número"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Serie / Número"
                                        />
                                    </div>
                                </div>
                            }
                            {editar === true &&
                                <div className='row mb-3'>
                                    <div className='col-2'>
                                        <Field
                                            name="fecha"
                                            disabled = {true}
                                            placeholder="Fecha"
                                            className="form-control-find"
                                            component={renderDayPickerB}
                                            msj="Fecha"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="tipo_mod"
                                                disabled={disabled}
                                                options={tipoPedido}
                                                crear={crear}
                                                dato={tipo}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Tipo"
                                            />
                                        </div>
                                    </div>
                                    <div className='col-2'>
                                        <Field
                                            name="pedido"
                                            placeholder="Serie / Número"
                                            className="form-control-find"
                                            disabled={true}
                                            component={renderField}
                                            msj="Serie / Número"
                                        />
                                    </div>
                                </div>
                            }
                            {crear === true &&
                                <div className='row mb-3'>
                                    <div className='col-2'>
                                        <Field
                                            name="fecha"
                                            placeholder="Fecha"
                                            className="form-control-find"
                                            component={renderDayPickerB}
                                            msj="Fecha"
                                        />
                                    </div>
                                    <div className='col-2'>
                                        <div className="form-floating">
                                            <Field
                                                name="tipo"
                                                disabled={disabled}
                                                options={tipoPedido}
                                                crear={crear}
                                                dato={0}
                                                component={SelectField}
                                                className="form-select"
                                                msj="Tipo"
                                            />
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className='row mb-3'>
                                <div className='col-12'>
                                    <Field
                                        name="observaciones"
                                        placeholder="Observaciones"
                                        component={renderField}
                                        className="form-control"
                                        disabled={disabled}
                                        msj="Observaciones"
                                    />
                                </div>
                            </div>
                            {(crear === true || editar === true) &&
                                <div>
                                    <h5 className="p-2 bg-secondary title mt-1">Detalle pedido</h5>
                                    <div className='row mb-3'>
                                        <div className='col-6'>
                                            <Field
                                                name="producto"
                                                placeholder="Producto..."
                                                className="form-control-find"
                                                component={AsyncSelectField}
                                                loadOptions={listarProductos}
                                                onChange={(e) => {
                                                    handleOnChangeProducto(e)
                                                }}
                                                msj="Producto"
                                            />
                                        </div>
                                        <div className='col-2'>
                                            <Field
                                                name="cantidad"
                                                placeholder="Cantidad"
                                                className="form-control"
                                                component={renderNumber}
                                                onChange={(e, value) => {
                                                    if (value) {
                                                        if (precioV){
                                                            let totalL = parseFloat(parseFloat(precioV) * parseInt(value)).toFixed(2);
                                                            setTotal(totalL);
                                                        }
                                                    }
                                                }}
                                                msj="Cantidad"
                                            />
                                        </div>
                                        <div className='col-2'>
                                            <div className="form-floating">
                                                <NumberFormat
                                                    className={classNames('form-control')}
                                                    decimalScale={2}
                                                    disabled={true}
                                                    placeholder="Precio Unitario"
                                                    fixedDecimalScale
                                                    thousandSeparator
                                                    value={precioV}
                                                    name="precioVenta"
                                                />
                                                <label className='form-label' htmlFor="total">
                                                    Precio
                                                </label>
                                            </div>
                                        </div>
                                        <div className='col-2'>
                                            <div className="form-floating">
                                                <NumberFormat
                                                    className={classNames('form-control')}
                                                    decimalScale={2}
                                                    disabled={true}
                                                    placeholder="Total"
                                                    fixedDecimalScale
                                                    thousandSeparator
                                                    value={total}
                                                    name="total"
                                                />
                                                <label className='form-label' htmlFor="total">
                                                    Total
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                            {(crear === true) &&
                                <Contenido>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => {
                                            agregarLinea(periodo);
                                            setPrecioVenta(0.00);
                                            setTotal(0.00);
                                        }}
                                    >
                                        Agregar linea
                                    </button>
                                </Contenido>
                            }
                            {(editar === true) &&
                                <Contenido>
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={agregarLineaProducto}
                                    >
                                        Agregar linea
                                    </button>
                                </Contenido>
                            }
                            {crear === true &&
                                <div style={estilo}>
                                    <DetalleVenta
                                        detalle={detallePro}
                                        eliminarLinea={eliminarLinea}
                                    />
                                </div>
                            }
                            {(crear === false && editar === false) &&
                                <div>
                                    <h5 className="p-2 bg-secondary title mt-1">Detalle pedido</h5>
                                    <div style={estilo}>
                                        <DetalleVentaVer
                                            detalle={detalleProducto}
                                        />
                                    </div>
                                </div>
                            }
                            {editar === true &&
                                <div style={estilo}>
                                    <DetalleVentaMod
                                        detalle={detalleProducto}
                                        eliminarLineaProducto={eliminarLineaProducto}
                                    />
                                </div>
                            }
                            <div className='d-flex flex-row mt-3 ml-2'>
                                {crear === true &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => registroVenta(periodo)}
                                    >
                                        Guardar
                                    </button>
                                }
                                {editar === true &&
                                    <button
                                        className='btn mr-2 mb-3 btn-primary'
                                        onClick={() => modificarVenta()}
                                    >
                                        Modificar
                                    </button>
                                }
                                <a
                                    href={`/#/rr_hh/${id_emp[5]}/venta_empleado/${id_emp[7]}`}
                                    className='btn btn-secondary mb-3'
                                >
                                    Regresar
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

VentaEmpleadoForm.propTypes = {
    handleSubmit: PropTypes.func,
    crear: PropTypes.bool,
    lectura: PropTypes.object,
    modulo: PropTypes.object
};

const Contenido = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

`;

export default reduxForm({
    form: 'FormVentaEmpleado',
})(VentaEmpleadoForm);
